import React from 'react';
import PropTypes from 'prop-types';

function Container(props) {
    const additionalClassNames = props.additionalClassNames || [];
    const containerClassNames = ['floating-label-element'].concat(additionalClassNames);
    const labelClassNames = ['floating-label-element__label'];
    const loadingClassNames = ['floating-label-element__loading'];
    const hintClassNames = ['floating-label-element__hint'];

    if (props.disabled) {
        containerClassNames.push('floating-label-element--disabled');
    }

    if (props.loading && !props.hasValue) {
        loadingClassNames.push('floating-label-element__loading--show');
    }

    if (props.highlight && !props.hasValue) {
        hintClassNames.push('floating-label-element__hint--highlighted');
    }
    
    if (props.invalid) {
        hintClassNames.push('floating-label-element__hint--invalid');
    }

    if (props.hasValue) {
        containerClassNames.push('floating-label-element--has-value');
        labelClassNames.push('floating-label-element__label--visible');
        hintClassNames.push('floating-label-element__hint--has-value');
    }

    let hintText;
    if (props.invalid && props.errorText) {
        hintText = props.errorText;
    } else if (props.hintText) {
        hintText = props.hintText;
    } else {
        hintText = '';
    }

    return (
        <div className={containerClassNames.join(' ')}>
            <span className={labelClassNames.join(' ')} title={props.label}>{props.label}</span>
            <span className={loadingClassNames.join(' ')} />
            <div className="floating-label-element__input-container">
                {props.children}
            </div>
            <span className={hintClassNames.join(' ')} title={hintText}>{hintText}</span>
        </div>
    );
}

Container.propTypes = {
    label: PropTypes.string.isRequired,
    hasValue: PropTypes.bool.isRequired,
    highlight: PropTypes.bool,
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    hintText: PropTypes.string,
    errorText: PropTypes.string,
    additionalClassNames: PropTypes.array
};

Container.defaultProps = {
    highlight: false,
    disabled: false,
    loading: false,
    hintText: '',
    errorText: '',
    additionalClassNames: []
};

export default Container;
